// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2urVA","head":"ProcedureTableInfo_head__3qCiO"};